import { CSSTransition } from "react-transition-group";
import { createGlobalStyle } from "styled-components";
import { forwardRef } from "react";

const CSSTransitionStyle = createGlobalStyle`
  .css-transition-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  .css-transition-enter-active {
    opacity: 1;
    transform: translateY(5px);
    transition: transform 300ms, opacity 300ms;
  }
  .css-transition-enter-done {
    opacity: 1;
    transform: translateY(5px);
  }
  .css-transition-exit {
    opacity: 1;
    transform: translateY(5px);
  }
  .css-transition-exit-active {
    opacity: 0;
    transform: translateY(0px);
    transition: transform 300ms, opacity 300ms;
  }
`;
const CustomCSSTransition = forwardRef(
  ({ timeout, classNames, inValue, children }, nodeRef) => {
    const CSSTransitionProps = {
      timeout: timeout,
      classNames: classNames,
      unmountOnExit: true,
      in: inValue,
      nodeRef: nodeRef,
      mountOnEnter: true,
    };

    return (
      <>
        <CSSTransitionStyle />
        <CSSTransition {...CSSTransitionProps} mountOnEnter>
          {children}
        </CSSTransition>
      </>
    );
  }
);

CustomCSSTransition.defaultProps = {
  timeout: 700,
  classNames: "css-transition",
  unmountOnExit: true,
};

export default CustomCSSTransition;
